// polyfill closest IE11
const closest = () => {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector
    }
    Element.prototype.closest = function (s) {
      if (!document.documentElement.contains(this)) return null
      if (this.matches(s)) return this
      let ancestor = this.parentElement
      while (ancestor !== null) {
        if (ancestor.matches(s)) return ancestor
        ancestor = ancestor.parentElement
      }
      return null
    }
  }
}

export { closest }